module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('topnav', {
    attrs: {
      "toptype": _vm.toptype
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "min-height": "600px"
    }
  }, [_c('div', {}, [_c('el-image', {
    staticClass: "topimg",
    attrs: {
      "src": _vm._f("addurl")(_vm.timg),
      "fit": "fill"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "response bggray",
    staticStyle: {
      "padding": "30px 0"
    }
  }, [_c('div', {
    staticClass: "marginauto comswidth"
  }, [_c('div', {
    staticClass: "marginauto",
    staticStyle: {
      "width": "50%"
    }
  }, [_c('div', {
    staticClass: "text-center",
    staticStyle: {
      "color": "#1b1b1b",
      "font-size": "28px",
      "margin-bottom": "70px",
      "font-weight": "600"
    }
  }, [_vm._v("\n                        请填写入驻信息\n                    ")]), _vm._v(" "), _c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-width": "200px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "企业名称",
      "prop": "shop_name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入企业名称"
    },
    model: {
      value: (_vm.ruleForm.shop_name),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "shop_name", $$v)
      },
      expression: "ruleForm.shop_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系人",
      "prop": "people_name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入联系人"
    },
    model: {
      value: (_vm.ruleForm.people_name),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "people_name", $$v)
      },
      expression: "ruleForm.people_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系方式",
      "prop": "mobile"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入联系方式"
    },
    model: {
      value: (_vm.ruleForm.mobile),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "mobile", $$v)
      },
      expression: "ruleForm.mobile"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "入驻地址",
      "prop": "site_id"
    }
  }, [_c('el-cascader', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择注册地址",
      "options": _vm.addresslist,
      "props": {
        expandTrigger: 'hover',
        value: 'id',
        label: 'name',
        children: 'children',
      }
    },
    on: {
      "change": _vm.chooseArea
    },
    model: {
      value: (_vm.ruleForm.site_id),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "site_id", $$v)
      },
      expression: "ruleForm.site_id"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('ruleForm')
      }
    }
  }, [_vm._v("提交申请")])], 1)], 1)], 1)])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-36db260d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/companyinfo.vue
// module id = 393
// module chunks = 1